import { combineReducers, configureStore } from "@reduxjs/toolkit";
import mapSliceReducer from "../reducers/MapSlice";
import categoriesReducer from "../reducers/CategoriesSlice";
import indicesReducer from "../reducers/IndicesSlice";
import authReducer, { logout } from "../reducers/AuthSlice";
import settingsReducer from "../reducers/SettingsSlice";

const appReducer = combineReducers({
  mapState: mapSliceReducer,
  categories: categoriesReducer,
  indices: indicesReducer,
  auth: authReducer,
  settings: settingsReducer,
});

// Logout puts every slice back to its starting state, except device settings,
// so the next user starts clean without a page reload.
const rootReducer = (state, action) =>
  appReducer(
    action.type === logout.type ? { settings: state?.settings } : state,
    action,
  );

export default configureStore({ reducer: rootReducer });
